import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import CategoryForm from "../form";

const UpdateCategory = () => {
  const { categoryId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Category" />
      <div className="p-6 max-w-2xl">
        <CategoryForm categoryId={categoryId} />
      </div>
    </div>
  );
};

export default UpdateCategory;
